import { useState, useEffect } from 'react';
import {
  ontologyApi,
  OntologyTreeGrouped,
} from '../services/api';

let _cache: OntologyTreeGrouped | null = null;
let _pending: Promise<OntologyTreeGrouped> | null = null;

export function useOntologyTree() {
  const [tree, setTree] = useState<OntologyTreeGrouped | null>(_cache);
  const [loading, setLoading] = useState(!_cache);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (_cache) return;
    if (!_pending) {
      _pending = ontologyApi.getTree();
    }
    let cancelled = false;
    setLoading(true);
    _pending
      .then((data) => {
        _cache = data;
        if (!cancelled) setTree(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err?.message ?? 'Failed to load ontology');
      })
      .finally(() => {
        _pending = null;
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { tree, topics: tree, loading, error };
}

/** @deprecated Use useOntologyTree */
export const useTopics = useOntologyTree;
